import router from '../router'
export default {
  // 金额判断格式化100.00
  RMB(n) {
    let x = n + '';
    let xx = x.split('.');
    if (n == null) {
      return '0.00';
    }
    if (xx.length == 1) {
      return n + '.00';
    } else if (xx.length == 2 && xx[1].length == 1) {
      return n + '0';
    } else {
      return n;
    }
  },
  test() {
    router.push(
      {
        name:"payResult",
        query:{
          result:1
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/utils/moneyFormat.js